import type { BooleanFilterState } from '../../../common/constants/filters/boolean-filter/types';

/** Returns a getState accessor for a boolean filter's query parameters. */
export const generateQueryParamsGetState = <ID extends string>(
	initialState: BooleanFilterState<ID>,
	queryParamKey: string,
) => {
	return (queryParams: Record<string, string[]>): BooleanFilterState<ID> => {
		const queryParamValue = queryParams[queryParamKey];
		const booleanValue = queryParamValue?.[0] === 'true' ? true : false;
		return {
			...initialState,
			value: booleanValue || initialState.value,
		};
	};
};
